//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/AssemblyNavigatorValidator.js";
import "../no/PartNavigatorValidator.js";
import "../no/DebugSession.js";
let d=[[],[[["part"],"CreatePartNavigatorValidator",{R_:{validator:"PartNavigatorValidator"}},1,0],[["rootPart"],"CreateAssemblyNavigatorValidator",{R_:{assemblyNavigatorvalidator:"AssemblyNavigatorValidator"}},1,0],[["flag"],"SetNavigatorUIAutotestEnabled",{},1,0],[["columnValidationFlag"],"SetColumnValidation",{},1,0],[[],"GetColumnValidation",{R_:{columnValidationFlag:''}},0,0],[["selectiveNodeValidationFlag"],"SetSelectiveNodeValidation",{},1,0],[[],"GetSelectiveNodeValidation",{R_:{selectiveNodeValidationFlag:''}},0,0]],[]];
SPLM.NavigatorAutotestPrint = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.NavigatorAutotestPrint";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;